import {Inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {LOCAL_STORAGE, SESSION_STORAGE, StorageService} from 'ngx-webstorage-service';
import {AlertService} from 'ngx-alerts';


@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router, @Inject(LOCAL_STORAGE) private storage: StorageService,
              private alertService: AlertService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this.storage.get('gs-loggedInUser')) {
      this.alertService.danger('UnAuthorized Please login before accessing the page');
      this.storage.clear();
      this.router.navigate(['/account/login']);
      return false;
    }
    let userType = this.storage.get('gs-loggedInUserType');
    let currentPath = route['_routerState']['url'];

    //Redirecting to respective dashboard route
    if (userType && userType.toLowerCase() == 'drivingschool' && (!currentPath || (currentPath && currentPath == '/'))) {
      //redirecting the user to driving school dashboard
      this.router.navigate(['/driving-school/']);
    }
    return true;

  }

}
